import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { theme } from 'utils/style/theme';

/**
 * * 기본 FORM 모달 : antd 사용
 * ! 2023.1.5
 * - form 폴더에 있는 SmallModal을 이걸로 변경하면 좋겠다.
 */

interface IProps {
  title: string;
  onCancel: (e: any) => void;
  children?: JSX.Element[] | JSX.Element;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
  visible?: boolean;
  footer?: null | JSX.Element[] | JSX.Element;
  top?: string;
}
const DefaultModal = ({
  children,
  title,
  onCancel,
  visible,
  style,
  width,
  height,
  footer,
  top,
}: IProps) => {
  return (
    <StyledModal
      open={visible}
      title={title}
      onCancel={onCancel}
      footer={footer}
      style={style}
      width={width}
      height={height}
      top={top}
    >
      {children}
    </StyledModal>
  );
};

export default DefaultModal;

const StyledModal = styled(Modal)<IProps>`
  width: ${(props) => (props.width ? props.width : '')} !important;
  top: ${(props) => (props.top ? props.top : '')};

  .ant-form-item-label > label {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${theme.colors.black};
    margin-left: 0.2rem;
    width: 7.5rem;
    &::after {
      content: '';
    }
  }
  .ant-modal-content,
  .ant-modal-header {
    background-color: ${theme.colors.gray_1};
  }
  .ant-modal-header {
    border-bottom: 1px solid ${theme.colors.gray_4};
  }

  .ant-modal-title {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.lg};
    font-weight: ${theme.fontWeights.bold};
    margin: 0.5rem 0 0 0;
  }

  .ant-modal-body {
    /* 모달 내부 여백 */
    /* padding: 0.5rem 2rem 0.5rem 2rem; */
    max-height: 52rem;
    /* overflow: auto; */
  }
  .ant-modal-footer {
    margin-top: 2rem;
  }
  .submit_button_wrap {
    text-align: center;
  }
  .dropzone {
    width: 100%;
  }
`;
